var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    quizEntryBankBackgroundColor: colors.white,
    quizEntryBankBorder: "".concat(borders.widthSmall, " dashed ").concat(colors.oxford),
    quizEntryBankPadding: "".concat(spacing.xxSmall, " ").concat(spacing.medium),
    quizEntryBankTopMargin: spacing.small,
    alertWrapperMargin: spacing.small
  };
};
export default generateComponentTheme;